var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKartlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 115 95",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.433 46.773l11.313-5.88 56.569 29.4-11.313 5.879z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M102.256 40.893l11.313 5.88L57.001 76.17l-11.314-5.88zM1.001 64.738l11.314-5.88 56.569 29.4-11.314 5.879z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M102.824 58.859l11.313 5.88L57.57 94.137l-11.314-5.88zM.001 29.399l11.314-5.88 56.569 29.4-11.314 5.879z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M101.824 23.519l11.313 5.88L56.57 58.797l-11.314-5.88z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M113.138 29.399l-11.313 5.88-56.57-29.4L56.57 0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.314 35.278L.001 29.398 56.57 0l11.313 5.88z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKartlag);
export default __webpack_public_path__ + "static/media/kartlag.60945850.svg";
export { ForwardRef as ReactComponent };